module.exports = __webpack_public_path__ + "media/images/gallery/constellations/coma_berenices/com_dir-ed7a9e109da703e884002b16ef5cc54c.gif";